import type { IconProps } from '../types/IconProps.ts';
export const ShieldUser: IconProps = {
    name: 'ShieldUser',
    children: [
        `<path d="M4 5.2q.02-.21.23-.23c2.45-.02 4.83-.83 6.79-2.3l.8-.61c.1-.08.25-.08.35 0l.81.6a11.4 11.4 0 0 0 6.8 2.3q.2.01.22.24v6.73A10.3 10.3 0 0 1 11.98 22 10.3 10.3 0 0 1 4 11.93z" />`,
        `<path d="M12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6M17.5 18.5c0-2.2-2.74-4.5-5.5-4.5s-5.5 2.3-5.5 4.5" />`,
    ]
};